import axios from "axios";
import { API_BASE_URL } from "./constants";

/**
 * Public storefront config (ADR-0011 / #139).
 * Uses raw axios so JWT refresh interceptor cannot redirect to /login on 401.
 */
export async function fetchStorefrontConfig() {
  const { data } = await axios.get(`${API_BASE_URL}/v1/storefront/config/`, {
    headers: { "Content-Type": "application/json" },
    timeout: 15000,
  });
  return data;
}
